// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__28D9g","large":"styles_large__1Tphu"};